import { render, staticRenderFns } from "./PersonTagManager.vue?vue&type=template&id=a0fdc208&"
import script from "./PersonTagManager.vue?vue&type=script&lang=js&"
export * from "./PersonTagManager.vue?vue&type=script&lang=js&"
import style0 from "./PersonTagManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports